<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="c-indicator c-indicator-w-100">
        <TableHead></TableHead>
        <tbody v-for="(child, childIndex) in childs">
          <tr class="back-jur">
            <td colspan="1">{{ index }}.{{ childIndex + 1 }}</td>
            <td colspan="12">
              <b>{{ child.SECTION_NAME }}</b>
            </td>
          </tr>

          <TableRow
            v-for="(doc, docIndex) in child.TYPE_LIST_ID"
            :index="index + '.' + (childIndex + 1)"
            :doc-index="docIndex"
            :doc="doc"
            :document-conf="documentConf"
            :document-history="documentHistory"
            :record="child.RECORD_MODEL_ID"
          ></TableRow>
          <UploadRow
            v-if="child.TYPE_LIST_ID && child.TYPE_LIST_ID.length > 0"
            :parent="child"
            :docs="child.TYPE_LIST_ID"
            :sub-index="0"
            :project="project"
            :document-conf="documentConf"
          ></UploadRow>
          <template v-for="(subchild, subChildIndex) in child.CHILD">
            <fragment>
              <tr class="back-jur">
                <td>
                  {{ index }}.{{
                    childIndex +
                      1 +
                      (child.TYPE_LIST_ID ? child.TYPE_LIST_ID.length : 0)
                  }}.{{ subChildIndex + 1 }}
                </td>
                <td colspan="12">
                  <b>{{ subchild.SECTION_NAME }}</b>
                </td>
              </tr>
              <template v-for="(subchild, subChildIndex2) in subchild.CHILD">
                <tr class="back-jur">
                  <td>
                    {{ index }}.{{
                      childIndex +
                        1 +
                        (child.TYPE_LIST_ID ? child.TYPE_LIST_ID.length : 0)
                    }}.{{ subChildIndex + 1 }}.{{ subChildIndex2 + 1 }}
                  </td>
                  <td colspan="12">
                    <b>{{ subchild.SECTION_NAME }}</b>
                  </td>
                </tr>
                <TableRow
                  v-for="(doc, docIndex) in subchild.TYPE_LIST_ID"
                  :index="
                    index +
                      '.' +
                      (childIndex +
                        1 +
                        (child.TYPE_LIST_ID ? child.TYPE_LIST_ID.length : 0)) +
                      '.' +
                      (subChildIndex + 1) +
                      '.' +
                      (subChildIndex2 + 1)
                  "
                  :doc-index="docIndex"
                  :doc="doc"
                  :document-conf="documentConf"
                  :document-history="documentHistory"
                  :record="subchild.RECORD_MODEL_ID"
                ></TableRow>
                <UploadRow
                  :docs="subchild.TYPE_LIST_ID"
                  :parent="subchild"
                  :sub-index="subChildIndex"
                  :project="project"
                  :document-conf="documentConf"
                ></UploadRow>
              </template>
              <TableRow
                v-for="(doc, docIndex) in subchild.TYPE_LIST_ID"
                :index="
                  index + '.' + (childIndex + 1) + '.' + (subChildIndex + 1)
                "
                :doc-index="docIndex"
                :doc="doc"
                :document-conf="documentConf"
                :document-history="documentHistory"
                :record="subchild.RECORD_MODEL_ID"
              ></TableRow>
              <UploadRow
                :docs="subchild.TYPE_LIST_ID"
                :parent="subchild"
                :project="project"
                :sub-index="childIndex"
                :document-conf="documentConf"
              ></UploadRow>
            </fragment>
          </template>
          <UploadRow
            v-if="!child.CHILD && false"
            :parent="child"
            :docs="child.TYPE_LIST_ID"
            :sub-index="0"
            :project="project"
            :document-conf="documentConf"
          ></UploadRow>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TableHead from "@/components/project/documents/TableHead";
import UploadRow from "@/components/project/documents/UploadRow";
import TableRow from "@/components/project/documents/TableRow";

export default {
  components: { TableRow, UploadRow, TableHead },
  props: [
    "docs",
    "documentConf",
    "index",
    "childs",
    "project",
    "documentHistory"
  ],
  name: "MultiDocumentTable"
};
</script>

<style scoped></style>
